import React from "react";
import BasePanel from "../base-panel";
import "./error-panel.scss";

const ErrorPanel = props => {
    return <BasePanel {...props} _class="error-panel" />;
};

export default ErrorPanel;
